import { BackgroundProps } from '@chakra-ui/react';
import React, { createContext, PropsWithChildren, useContext } from 'react';

import { ObjectType, TypeUtils } from '../../framework/utils/UtilityTypes';
import { DeadlineCategory } from '../models/gen/deadlineCategory';

type MessageColor = Partial<
  Record<DeadlineCategory, BackgroundProps['backgroundColor']>
>;
type MessageContext = MessageColor & {
  get: (type?: DeadlineCategory) => BackgroundProps['backgroundColor'];
};
type ColorContext = {
  messageBackground: MessageContext;
  messageDivider: MessageContext;
  messageText: MessageContext;
};

const contextValue: ColorContext = {
  messageBackground: { get: () => undefined },
  messageDivider: { get: () => undefined },
  messageText: { get: () => undefined },
};
const colorContext = createContext<ColorContext>(contextValue);

export const useColorContext = () => useContext(colorContext);

const generateValue = <T extends ObjectType>(obj: T) => ({
  ...obj,
  get: (key?: keyof T) => (TypeUtils.isNil(key) ? undefined : obj[key]),
});
export const ColorProvider: React.FunctionComponent<PropsWithChildren> = (
  props
) => {
  const values: ColorContext = {
    messageBackground: generateValue({
      DELAYED: 'red.500',
      NOTICE: 'blue.100',
      REMINDER: 'green.200',
      WARNING: 'orange.200',
    }),
    messageDivider: generateValue({
      DELAYED: 'red',
      NOTICE: 'blue',
      REMINDER: 'green',
      WARNING: 'orange',
    }),
    messageText: generateValue<MessageColor>({
      DELAYED: 'white',
    }),
  };

  return (
    <colorContext.Provider value={values}>
      {props.children}
    </colorContext.Provider>
  );
};
